
















































import Vue from 'vue'
import {Component} from 'vue-property-decorator'

import SocialList from '@/views/Home/SocialList.vue'
import ToolList from '@/views/Home/ToolList.vue'
import TechList from '@/views/Home/TechList.vue'
import CertList from '@/views/Home/CertList.vue'
import About from '@/views/Home/About.vue'

@Component({
  components: {About, SocialList, ToolList, TechList, CertList}
})
export default class Home extends Vue {
  showMore = false

  get showMoreText() {
    return this.showMore ? 'Collapse' : 'More About Me'
  }
}
